import React from 'react';
import { iconInner } from '@/lib/deviceIcons';

export const DeviceIcon = ({ type, size = 40, className }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
    dangerouslySetInnerHTML={{ __html: iconInner(type) }}
  />
);
